import { ENV } from "../utils";

export class PerfilesPuesto {
  baseApi = ENV.BASE_API;

  async getAll(accessToken, { departamento, activo, search, page = 1, limit = 10 } = {}) {
    const params = new URLSearchParams({ page, limit });
    if (departamento) params.append("departamento", departamento);
    if (activo !== undefined && activo !== "") params.append("activo", activo);
    if (search) params.append("search", search);

    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}?${params}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async getById(accessToken, id) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async create(accessToken, data) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async update(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}/${id}`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async toggleEstado(accessToken, id, activo) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}/${id}/estado`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ activo }),
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async delete(accessToken, id) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async extraerPDF(accessToken, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO_EXTRAER_PDF}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
      body: formData,
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  async generarMarkdown(accessToken, perfilJson) {
    const response = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PERFILES_PUESTO_GENERAR_MARKDOWN}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(perfilJson),
    });
    const result = await response.json();
    if (!response.ok) throw result;
    return result;
  }
}
